<template>
  <div v-if="DragDrop == true && Download == false && DropDown == false">
    <v-card
      @drop.prevent="onDrop($event)"
      @dragover.prevent="dragover = true"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
      :class="{ 'grey lighten-2': dragover }"
      class="card-Drop"
    >
      <v-card-text class="DragDrop">
        <v-row class="d-flex" dense style="justify-content: center">
          <v-col  cols="12">
            <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60" style="color: #9747ff"> mdi-upload </v-icon>
          </v-col>
          <v-col cols="12">
            <p style="font-size: 20px; font-weight: 700; background: -webkit-linear-gradient(#9747ff, #5179ef); -webkit-background-clip: text; -webkit-text-fill-color: transparent">
              BROWSE FILES TO UPLOAD
            </p>
          </v-col>
        </v-row>
        <input v-if="multiple" :disabled="DisabledBtn" type="file" :accept="accept" multiple ref="uploader" @change="onClick($event)" />
        <input v-else type="file" :disabled="DisabledBtn" ref="uploader" :accept="accept" @change="onClick($event)" />
      </v-card-text>
    </v-card>
    <v-virtual-scroll v-if="uploadedFiles.length > 0 && ShowListFile" :items="uploadedFiles" height="150" item-height="50">
      <template v-slot:default="{ item }">
        <v-list-item :key="item.name">
          <v-list-item-content>
            <v-list-item-title>
              {{ item.name }}
              <span class="ml-3 text--secondary"> {{ item.size }} bytes</span>
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn @click.stop="removeFile(item.name)" icon>
              <v-icon> mdi-close-circle </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-divider></v-divider>
      </template>
    </v-virtual-scroll>
  </div>

  <div v-else-if="DragDrop == false && Download == false && IconBtn == false && DropDown == false" >
    <v-card-text class="NoDragDrop" style="padding: 0">
      <!-- <v-btn
      primary
      color="indigo"
      @click="handleFileImport"
      style="width: 50px;height: 55px; color: #ffffff"
    > -->
      <!-- {{ $t("upload") }} -->
      <!-- <v-icon size="30">mdi-upload</v-icon>
    </v-btn> -->
      <v-btn class="primary white--text mt-3" style="margin-left: 1em" :disabled="DisabledBtn" @click="handleFileImport">
        <v-img v-if="newUploadIcon" :src="uploadIcon" alt="Edit Icon" height="20" width="22" class="mr-2" />
        <v-icon v-else size="20" style="padding-right: 5px">mdi-upload</v-icon>
        {{NameButton}}</v-btn
      >
      <input v-if="multiple" ref="uploader" class="d-none" type="file" multiple :accept="accept" :disabled="DisabledBtn" @change="onClick($event)" />
      <input v-else :key="accept" ref="uploader" class="d-none" type="file" :accept="accept" :disabled="DisabledBtn" @change="onClick($event)" />
      <v-virtual-scroll v-if="uploadedFiles.length > 0 && ShowListFile" :items="uploadedFiles" height="80" item-height="50">
        <template v-slot:default="{ item }">
          <v-list-item :key="item.name">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.name }}
                <span class="ml-3 text--secondary"> {{ item.size }} bytes</span>
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn @click.stop="removeFile(item.name)" icon>
                <v-icon> mdi-close-circle </v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <v-divider></v-divider>
        </template>
      </v-virtual-scroll>
    </v-card-text>
  </div>
  
  <div v-else-if="DragDrop == false && Download == false && IconBtn == false && DropDown == true" >
    <v-card-text class="NoDragDrop" style="padding: 0">
        <v-menu location="bottom">
          <template v-slot:activator="{ props }">
            <v-btn 
              variant="outlined"
              color="success"
              class="template-btn upload-btn" 
              style="margin-left: 1em" 
              v-bind="props"
              :disabled="DisabledBtn"
            > 
              <v-icon size="20" style="padding-right: 5px">mdi-upload</v-icon>
              {{NameButton}}
            </v-btn>
          </template>
          <v-card min-width="200" elevation="8" rounded="lg">
            <v-list density="compact" nav class="pa-2">
              <v-list-item
                class="template-item"
                prepend-icon="mdi-file-document"
                @click="handleFileImport('Normal Question')">
                <v-list-item-title class="text-subtitle-2">Normal Question</v-list-item-title>
              </v-list-item>
                      <v-divider></v-divider>
              <v-list-item 
                class="template-item"
                prepend-icon="mdi-link-variant"
                @click="handleFileImport('Chain Question')">
                <v-list-item-title class="text-subtitle-2">Chain Question</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      <input v-if="multiple" ref="uploader" class="d-none" type="file" multiple :accept="accept" :disabled="DisabledBtn" @change="onClick($event)" />
      <input v-else :key="accept" ref="uploader" class="d-none" type="file" :accept="accept" :disabled="DisabledBtn" @change="onClick($event)" />
    </v-card-text>
  </div>

  <div v-else-if="Download == true && DragDrop == false && DropDown == false">
    <v-card class="card-Drop">
      <v-card-text class="DragDrop">
        <v-row class="d-flex flex-column" dense>
          <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60" style="color: #9747ff"> mdi-download </v-icon>
          <p style="font-size: 20px; font-weight: 700; background: -webkit-linear-gradient(#9747ff, #5179ef); -webkit-background-clip: text; -webkit-text-fill-color: transparent">DOWNLOAD</p>
        </v-row>
      </v-card-text>
    </v-card>
  </div>

  <div v-else-if="DragDrop == false && Download == false && IconBtn == true && DropDown == false">
    <v-card-text class="NoDragDrop" style="padding: 0">
      <v-btn icon v-on:click="handleFileImport" :disabled="DisabledBtn">
        <v-icon class="mdi-rotate-90" style="color:#71717A; cursor: unset;" >mdi-attachment</v-icon>
      </v-btn>
      <input v-if="multiple" ref="uploader" class="d-none" type="file" multiple :accept="allowType" :disabled="DisabledBtn" @change="onClick($event)" />
      <input v-else :key="accept" ref="uploader" class="d-none" type="file" :accept="allowType" :disabled="DisabledBtn" @change="onClick($event)" />
      <v-virtual-scroll v-if="uploadedFiles.length > 0 && ShowListFile" :items="uploadedFiles" height="80" item-height="50">
        <template v-slot:default="{ item }">
          <v-list-item :key="item.name">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.name }}
                <span class="ml-3 text--secondary"> {{ item.size }} bytes</span>
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn @click.stop="removeFile(item.name)" icon>
                <v-icon> mdi-close-circle </v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <v-divider></v-divider>
        </template>
      </v-virtual-scroll>
    </v-card-text>
  </div>


</template>

<script>
import uploadSVG from '@/assets/images/white_upload.svg';

export default {
  name: 'DragDropFile',
  props: {
    newUploadIcon: {
      type: Boolean,
      default: false,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    allowType: {   
      type: Array,
      default: () => {
        return []; // ค่าเริ่มต้นเป็น array เปล่า
      }
    },
    DragDrop: {
      type: Boolean,
      default: true,
    },
    IconBtn: {
      type: Boolean,
      default: false,
    },
    Download: {
      type: Boolean,
      default: false,
    },
    ShowListFile: {
      type: Boolean,
      default: true,
    },
    DisabledBtn: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: '',
    },
    DropDown: {
      type: Boolean,
      default: false,
    },
    NameButton: {
      type: String,
      default: 'Upload',
    },
  },
  data() {
    return {
      uploadIcon: uploadSVG,
      dragover: false,
      uploadedFiles: [],
    };
  },
  methods: {
    closeDialog() {
      // Remove all the uploaded files
      this.uploadedFiles = [];
      // Close the dialog box
      this.$emit('update:dialog', false);
    },
    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex((file) => file.name === fileName);
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
      this.$emit('filesUploaded', this.uploadedFiles);
    },
    onDrop(e) {
      this.dragover = false;

      // If there are already uploaded files remove them
      if (this.uploadedFiles.length > 0) {
        this.uploadedFiles = [];
      }
      else if (!this.multiple && e.dataTransfer.files.length == 1) {
        if (this.allowType.length > 0 && this.allowType.indexOf(e.dataTransfer.files[0].type.toLowerCase()) == -1) {
          alert('Please Upload Correct Type!');
          this.uploadedFiles = [];
          this.$emit('filesUploaded', this.uploadedFiles);
          return;
        }
        this.uploadedFiles = [];
        this.uploadedFiles.push(e.dataTransfer.files[0]);
        this.$emit('filesUploaded', this.uploadedFiles);
      }
      else if (!this.multiple && e.dataTransfer.files.length > 1) {
        if (this.allowType.length > 0 && this.allowType.indexOf(e.dataTransfer.files[0].type.toLowerCase()) == -1) {
          alert('Please Upload Correct Type!');
          this.uploadedFiles = [];
          this.$emit('filesUploaded', this.uploadedFiles);
          return;
        }
        this.uploadedFiles = [];
        this.uploadedFiles.push(e.dataTransfer.files[0]);
        this.$emit('filesUploaded', this.uploadedFiles);
      } else {
        Array.from(e.dataTransfer.files).forEach((file) => {
          this.uploadedFiles.push(file);
        });
        this.$emit('filesUploaded', this.uploadedFiles);
      }
      this.$refs.uploader.value = '';
    },
    handleFileImport(type) {
      this.isSelecting = true;
      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );
      this.$emit('uploadType', type)
      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },
    onClick(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      } else if (!this.multiple && e.target.files.length == 1) {
        if (this.allowType.length > 0 && this.allowType.indexOf(e.target.files[0].type.toLowerCase()) == -1) {
          alert('Please Upload Correct Type!');
          this.uploadedFiles = [];
          this.$emit('filesUploaded', this.uploadedFiles);
          return;
        }
        this.uploadedFiles = [];
        this.uploadedFiles.push(e.target.files[0]);
        this.$emit('filesUploaded', this.uploadedFiles);
      } else {
        Array.from(files).forEach((file) => {
          this.uploadedFiles.push(file);
        });
        this.$emit('filesUploaded', this.uploadedFiles);
      }
      this.$refs.uploader.value = '';
    },
  },
  computed: {
    computedAccept() {
      return this.accept; // สามารถทำประมวลผลเพิ่มเติมได้ตามต้องการ
    },
  },
};
</script>
<style>
.card-Drop {
  box-shadow: 0px 4.608365535736084px 9.216731071472168px 0px rgba(0, 0, 0, 0.1) !important;
  border: 2px dashed #bdbdbd !important;
  background-color: #f5f6f8 !important;
}
.DragDrop {
  height: 215px !important;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.DragDrop input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.NoDragDrop input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.template-btn {
  text-transform: none;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.template-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-info), 0.3);
}

.template-item {
  transition: all 0.2s ease-in-out;
  border-radius: 6px;
  margin: 2px 4px;
}

.template-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.08);
  transform: translateX(4px);
}
.upload-btn.custom-green {
  border-color: #4CAF50 !important;
  color: #4CAF50 !important;
}

.upload-btn.custom-green:hover:not(:disabled) {
  background-color: rgba(76, 175, 80, 0.08) !important;
  border-color: #4CAF50 !important;
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.3) !important;
}

.upload-btn.custom-green .v-icon {
  color: #4CAF50 !important;
}
</style>
